import { render, staticRenderFns } from "./logisStockListV0.vue?vue&type=template&id=f4c75852"
import script from "./logisStockListV0.vue?vue&type=script&lang=js"
export * from "./logisStockListV0.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports